export default __webpack_public_path__ + "static/media/eye.052344c2.svg";